import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    display: 'flex',
    gap: 16,
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 0
    }
  },

  footerButtonContainer: {
    marginTop: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  buttonWrapper: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },

    width: 'max-content',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px'
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  }
}))
